export function buildGuestDocumentsPayload({
  docData = {},
  guest = {},
  booking = null,
  guestName = '',
  guestPhone = '',
  roomNumber = '',
} = {}) {
  const resolvedName = String(
    guestName
      || guest.name
      || [guest.first_name, guest.middle_name, guest.last_name].filter(Boolean).join(' ')
      || booking?.guest_name
      || '',
  ).trim();
  const resolvedPhone = String(
    guestPhone
      || guest.phone
      || booking?.guest_phone
      || booking?.phone
      || '',
  ).trim();

  return {
    id_front_url: docData.id_front_url || null,
    id_back_url: docData.id_back_url || null,
    document_type: docData.document_type || guest.document_type || 'ID Document',
    id_number: docData.id_number || guest.id_number || '',
    id_number_masked: docData.id_number_masked || guest.id_number_masked || '',
    guestName: resolvedName || null,
    guestPhone: resolvedPhone || null,
    bookingCode: booking?.code || null,
    guest,
    booking,
    roomNumber: roomNumber || '',
  };
}
